import {Component, inject} from '@angular/core';
import {RouterLink} from '@angular/router';
import {DeviceService} from '../../services/device.service';
import {MenuButton} from '../../model/menu-button';
import {AuthService} from '../../../core/auth/auth.service';
import {PermissionService} from '../../../core/services/permission.service';
import {SystemPower} from '../../../shared/model/permissions';
import {VersionService} from '../../services/version.service';

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {

  protected authService: AuthService = inject(AuthService);
  protected permissionService: PermissionService = inject(PermissionService);
  protected deviceService: DeviceService = inject(DeviceService);
  protected versionService: VersionService = inject(VersionService);
  protected readonly version = this.versionService.version;
  protected footerButtons: MenuButton[];

  constructor() {
    this.footerButtons = [
      {
        label: '',
        routerLink: '/games',
        icon: 'bi bi-controller',
        showCondition: () => this.isAdmin(),
        elementId: 'gamesBtn'
      },
      {
        label: '',
        routerLink: '/events',
        icon: 'bi bi-calendar-event',
        elementId: 'eventsBtn'
      },
      {
        label: '',
        routerLink: '/tables',
        icon: 'bi bi-table',
        elementId: 'tablesBtn'
      },
      {
        label: '',
        routerLink: '/organizations',
        icon: 'bi bi-building',
        elementId: 'organizationsBtn'
      },
      {
        label: '',
        routerLink: '/admin',
        icon: 'bi bi-shield-lock',
        showCondition: () => this.isAdmin(),
        elementId: 'adminBtn'
      },
      {
        label: '',
        routerLink: '/profile',
        icon: 'bi bi-person',
        showCondition: () => this.isLogged(),
        elementId: 'profileBtn'
      },
      {
        label: '',
        routerLink: '/login',
        icon: 'bi bi-box-arrow-in-right',
        showCondition: () => !this.isLogged(),
        elementId: 'loginBtn',
      },
      {
        label: '',
        action: () => this.authService.logout(),
        icon: 'bi bi-box-arrow-right',
        showCondition: () => this.isLogged(),
        elementId: 'logoutBtn'
      }
    ];
  }

  isLogged() {
    return this.permissionService.isLogged();
  }

  isAdmin() {
    return this.permissionService.hasSystemPower(SystemPower.ADMINISTRATOR);
  }

}






